<template>
  <v-autocomplete
    id="temas-select"
    v-model="value.statusId"
    :items="values"
    label="Status"
    placeholder="Selecione..."
    v-on:change="
      (e) => {
        $emit('onChange', value);
      }
    "
    :disabled="disabled"
    :clearable="clearable"
    :multiple="multiple"
    item-value="statusId"
    item-text="nome"
    :rules="rules"
    :outlined="outlined"
    hide-details="auto"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ value.municipioId.length - maxDisplay }} status)</span
      >
    </template>
    <template slot="no-data"> Nenhum Status retornado </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { territoriosStatusAPI } from "@/modules/gestao-territorios/API/territorioStatusAPI";

export default {
  name: "ComboboxMunicipioTerritorio",
  computed: {
    ...mapGetters(["isSala", "isParceiro"]),
  },
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    clearable: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: Array | Object },
    filterByTerritorios: { type: Number },
    outlined: { type: Boolean, default: false },
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadCities() {
      this.setLoading(true);
      territoriosStatusAPI
        .list()
        .then((resp) => {
          this.values = resp.data;
          this.allValues = resp.data;
          this.setLoading(false);
        })
        .catch((e) => {
          console.log("error on comboboxTerritorioStatus: ", e);
          this.$notification.error("Error ao buscar status");
          this.setLoading(false);
        });
    },
  },
  mounted() {
    this.loadCities();
  },

  data() {
    return {
      values: [],
      allValues: [],
      maxDisplay: 1,
    };
  },
};
</script>
